import Nav from 'react-bootstrap/Nav';
import './AdminPanel.css';
import Tab from 'react-bootstrap/Tab';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import EventManage from '../../components/AdminManage/Events/EventManage';
import UserManage from '../../components/AdminManage/Users/UserManagement';
import BookingManage from '../../components/AdminManage/Bookings/BookingManage';

const AdminPanel: React.FC = () => {
    return (
        <div className='admin_panel_container'>
            <h4>Администрирование</h4>
            <div className='admin_main'>
                <Tab.Container defaultActiveKey="tab1">
                    <Row>
                        <Col sm={2}>
                            <Nav variant="pills" className="flex-column">
                                <Nav.Item>
                                    <Nav.Link eventKey="tab1">События</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="tab2">Бронирования</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="tab3">Пользователи</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                        <Col sm={10}>
                            <Tab.Content>
                                <Tab.Pane eventKey="tab1">
                                    <h5>Управление событиями</h5>
                                    <EventManage/>
                                </Tab.Pane>
                                <Tab.Pane eventKey="tab2">
                                    <h5>Управление бронированиями</h5>
                                    <BookingManage/>
                                </Tab.Pane>
                                <Tab.Pane eventKey="tab3">
                                    <h5>Управление пользователями</h5>
                                    <UserManage/>
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </div>
        </div>
    );
};

export default AdminPanel;
